import { FormattedMessage } from "react-intl";
import { Message } from "./message";
import React from "react";
import { Box, Typography, styled, Chip, Divider } from "@mui/material";
import { CHAT_USERNAME_COLORS } from "../../../../../constants";
import {
  convertUnixTimeStamp,
  getCurrentDate,
  isYesterday,
} from "../../../../../helpers";

const resolveUsernameColor = (username, members = []) => {
  const memberIndex = members.findIndex(
    (member) => member.username === username
  );

  return CHAT_USERNAME_COLORS[memberIndex % CHAT_USERNAME_COLORS.length];
};

//set message dates (green dates in message container)
const getMessageDateIfNeeded = (createdAt, i, arr) => {
  if (!arr || arr.length === 0) return null; // Ensure the array is valid
  let oldTimestamp = arr[i - 1] ? arr[i - 1].createdAt : createdAt;
  let messageDate = convertUnixTimeStamp(createdAt);
  let oldMessageDate = convertUnixTimeStamp(oldTimestamp);
  //brauche eigentlich immer nur die letzte Nachricht des Tages
  if (messageDate !== oldMessageDate || i === 0) {
    let date;
    let currentDate = getCurrentDate();
    if (messageDate === currentDate) return (date = "Heute");
    else if (isYesterday(createdAt)) return (date = "Gestern");
    else return (date = messageDate);
  } else return null;
};

export const MessageWithTime = ({
  messageObject,
  messageIndex,
  dataMessages,
  chatType,
  messages,
  postingMessage,
  showDateSeparator,
}) => {
  const { _id: messageId, author } = messageObject;

  const date = getMessageDateIfNeeded(
    messageObject.createdAt,
    messageIndex,
    messages
  );

  // Ensure dataMessages.user and its nested properties are valid
  const members =
    dataMessages?.user?.chats?.chats?.[0]?.members || [];

  return (
    <TimeMessageWrapper key={"time_message_wrapper_" + messageIndex}>
      {date && (
        <DateSeparator>
          <Divider sx={{ flex: 1 }} />
          <DateChip
            label={date}
            size="small"
          />
          <Divider sx={{ flex: 1 }} />
        </DateSeparator>
      )}

      {showDateSeparator && (
        <NewMessagesChip
          id={"new_message_marker_" + messageId}
          key={"new_message_marker_" + messageId}
          label={<FormattedMessage id="chat.new-messages" />}
          size="small"
        />
      )}

      <Message
        key={"message_" + messageIndex}
        id={"message_" + messageIndex}
        authorColor={resolveUsernameColor(author.username, members)}
        lastMessage={messages[messageIndex - 1]}
        chatType={chatType}
        messageObject={messageObject}
        postingMessage={postingMessage} // Pass postingMessage prop
      />
    </TimeMessageWrapper>
  );
};

const TimeMessageWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

const DateSeparator = styled(Box)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  margin: "10px 0",
});

const DateChip = styled(Chip)(({ theme }) => ({
  fontSize: "12px",
  height: 24,
  borderRadius: 12,
  color: "#ffffff",
  backgroundColor: "#72deaa",
  fontWeight: 600,
}));

const NewMessagesChip = styled(Chip)(({ theme }) => ({
  alignSelf: "center",
  margin: "10px 0",
  fontSize: "13px",
  height: 26,
  borderRadius: 13,
  color: "#ffffff",
  backgroundColor: theme?.mainColor || "#E87975",
  boxShadow: "0 2px 8px rgba(232, 121, 117, 0.25)",
}));
